import { render, staticRenderFns } from "./BlockWrapper.vue?vue&type=template&id=f3c61780&"
import script from "./BlockWrapper.vue?vue&type=script&lang=ts&"
export * from "./BlockWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./BlockWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports